export default "__VITE_ASSET__BZJfeDhm__"